var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.253,
    height: 10.498,
    viewBox: "0 0 9.253 10.498",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-phone-1013972",
    transform: "translate(-5.938 -0.009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(5.938 0.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M9.25,2.5c.114.579-.136.753-.136.753l-.727.457c-.29.172-.132.531-.132.531a7.656,7.656,0,0,0,2.851,3.538c.331.238.533.069.533.069l.937-.781c.333-.326.586-.1.586-.1l1.848,1.381c.314.22.173.667-.053,1.053a2.458,2.458,0,0,1-2.32,1.081A7.361,7.361,0,0,1,8,7.326,14.964,14.964,0,0,1,6.078,3.318,2.644,2.644,0,0,1,7.023.338c1.219-.768,1.789.05,1.789.05S9.136,1.918,9.25,2.5Z",
    transform: "translate(-5.938 -0.009)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.467c4843dabb869d6069415a2776f176.svg";
export { ForwardRef as ReactComponent };